export default __webpack_public_path__ + "static/media/undraw_contact_us_15o2.97862ec0.svg";